export const ADD_SUBSCRIPTIONS = 'ADD_SUBSCRIPTIONS';
export const UPDATE_SUBSCRIPTION_AS_READ = 'UPDATE_SUBSCRIPTION_AS_READ';
